import { cn } from "@/lib/utils";
import { forwardRef } from "react";
import { APP_NAME } from "@/config/constants";
import { LogoSVG } from "@/components/ui/logoSVG";

type LogoProps = {
  className?: string;
  iconClassName?: string;
  showAppName?: boolean;
};

export const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ className, iconClassName, showAppName }, ref) => {
    return (
      <div className="flex items-center gap-3">
        <div
          className={cn(
            "overflow-hidden z-10 flex aspect-square items-center justify-center rounded-lg bg-linear-to-br from-primary to-primary/80 text-primary-foreground min-w-8 min-h-8",
            className,
          )}
        >
          <LogoSVG className={cn(iconClassName, "rotate-45 fill-white w-[40px] h-[40px]")} />
        </div>
        {showAppName && (
          <span className="font-semibold text-primary group-data-[collapsible=icon]:hidden">
            {APP_NAME}
          </span>
        )}
      </div>
    );
  },
);

Logo.displayName = "Logo";
